export const getClock = (timeControl, initialTime) => {
    if (timeControl) {
        return getServerClock(timeControl, initialTime);
    }
    return localClock;
};
const localClock = { now: () => new Date() };
const getServerClock = (timeControl, initialTime) => ({
    now: () => {
        const serverTime = getCurrentServerTime(timeControl, initialTime);
        if (!serverTime) {
            return new Date();
        }
        const oneMinutesInMilliseconds = 60 * 1000;
        const timeZoneOffsetMilliseconds = serverTime.getTimezoneOffset() * oneMinutesInMilliseconds;
        let currentTime = new Date(serverTime.getTime() - timeZoneOffsetMilliseconds);
        if (timeControl.lastServerReply) {
            let lastServerReplyDate = new Date(timeControl.lastServerReply);
            if (currentTime.getTime() - lastServerReplyDate.getTime() >= 60 * oneMinutesInMilliseconds) {
                currentTime = new Date(currentTime.getTime() - 60 * oneMinutesInMilliseconds);
            }
        }
        return currentTime;
    }
});
const getCurrentServerTime = (timeControl, initialTime) => {
    if (timeControl.initialized) {
        const serverTime = timeControl.getServerTime();
        if (serverTime) {
            return serverTime;
        }
    }
    return initialTime;
};
//# sourceMappingURL=clock.js.map